import { maska, mask } from 'maska';

export default {
  name: 'TextField',
  directives: {
    mask: maska,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'l',
      validator: (value) => {
        return ['m', 'l'].indexOf(value) !== -1;
      },
    },
    error: Boolean,
    errorMessage: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    required: Boolean,
    disable: Boolean,
    focus: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => {
        return ['text', 'textarea', 'password', 'email'].indexOf(value) !== -1;
      },
    },
    autogrow: Boolean,
    placeholder: {
      type: String,
      default: null,
    },
    persistentPlaceholder: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    pill: Boolean,
    mask: {
      type: String,
      default: null,
    },
    autocomplete: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      focused: false,
      autofilled: false,
    };
  },
  computed: {
    isTextArea() {
      return this.type === 'textarea';
    },
    invisiblePlaceholder() {
      const value = this.value ? this.value.replace(/\s/g, '\xa0') : '';

      if (this.persistentPlaceholder) return value;

      return this.value ? value : this.placeholder.replace(/\s/g, '\xa0');
    },
    placeholderValue() {
      return this.placeholder
        .substring(this.value.length)
        .replace(/\s/g, '&nbsp;')
        .trim();
    },
  },
  watch: {
    focus(value) {
      this.setFocus(value);
    },
  },
  mounted() {
    this.setFocus(this.focus);
  },
  methods: {
    setFocus(value) {
      setTimeout(() => {
        if (this.$refs.textarea) {
          value ? this.$refs.textarea.focus() : this.$refs.textarea.blur();
        }
        if (this.$refs.input) {
          value ? this.$refs.input.focus() : this.$refs.input.blur();
        }
      });
    },
    onFocus() {
      this.focused = true;
      this.$emit('focus');
    },
    onBlur() {
      this.focused = false;
      this.$emit('blur');
    },
    onInput(event) {
      this.$emit('input', event.target.value);
    },
    onInputArea(event) {
      if (this.mask) this.updateTextAreaValue(event, this.mask);

      this.$emit('input', event.target.value);

      if (!this.autogrow) return;

      const area = event.target;
      if (area.clientHeight < area.scrollHeight) {
        area.style.height = area.scrollHeight + 'px';
      }
    },
    updateTextAreaValue(event, maskValue) {
      let position = event.target.selectionEnd;
      const oldValue = event.target.value;
      const digit = oldValue[position - 1];

      event.target.value = mask(event.target.value, maskValue);

      if (event && event.inputType === 'insertText') {
        if (position === oldValue.length) {
          position = event.target.value.length;
        }
      }

      // Update input value
      event.target.value = mask(event.target.value, maskValue);

      // Set selection
      while (
        position &&
        position < event.target.value.length &&
        event.target.value.charAt(position - 1) !== digit
      ) {
        position++;
      }

      if (event.target === document.activeElement) {
        event.target.setSelectionRange(position, position);
        setTimeout(function () {
          event.target.setSelectionRange(position, position);
        }, 0);
      }
    },

    // https://ebaconline.atlassian.net/browse/FT-685
    // https://github.com/vuejs/vue/issues/1331
    checkAutoFillAnimation(e) {
      this.autofilled = true;
    },
    onEnter() {
      this.$emit('onEnter');
    },
  },
};
